export default "__VITE_ASSET__3cda7cdf__"